import { BoardCaseDetail } from '../board/BoardCaseDetail';
import { useAuthContext } from '../../contexts/AuthContext';
import { useSearchParams } from 'react-router-dom';
import { useZoneContext } from '../../contexts/useZoneContext';

function BoardCaseDetailWrapper() {
    const [searchParams] = useSearchParams();
    const { user } = useAuthContext();
    const zoneContext = useZoneContext();

    const type: string = searchParams.get('type') || '0';
    const id: string = searchParams.get('id') || '';
    const preferences: string = searchParams.get('preferences') || '';
    const date: any = searchParams.get('date') || null;
    return (
        <BoardCaseDetail
            user={user}
            type={type}
            id={id}
            date={date}
            preferences={preferences}
            zoneContext={zoneContext}
        />
    );
}

export default BoardCaseDetailWrapper;
